import { render, staticRenderFns } from "./DlGLTran.vue?vue&type=template&id=599c0ddc&"
import script from "./DlGLTran.vue?vue&type=script&lang=js&"
export * from "./DlGLTran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports